
import { PageMeta } from '../../components/shared/PageMeta';
import { Navigation } from '../../components/feature/Navigation';
import { BlogHeroSection } from './components/BlogHeroSection';
import { BlogCategoriesSection } from './components/BlogCategoriesSection';
import { BlogPostsSection } from './components/BlogPostsSection';
import { FooterSection } from '../../components/feature/FooterSection';
import { MinimalAurora } from '../../components/feature/MinimalAurora';

export default function BlogPage() {
  return (
    <div className="min-h-screen relative bg-black">
      <PageMeta path="/blog" />
      {/* Minimal Aurora Background */}
      <MinimalAurora />
      
      {/* Content */}
      <div className="relative z-10">
        <Navigation />
        <BlogHeroSection />
        <BlogCategoriesSection />
        <BlogPostsSection />
        <FooterSection />
      </div>
    </div>
  );
}
